import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Yodl could not finish opening.", error, info.componentStack);
  }

  override render() {
    if (!this.state.failed) return this.props.children;

    return (
      <main className="auth-screen" id="main-content">
        <section className="auth-card startup-recovery" aria-labelledby="startup-recovery-title">
          <div className="brand-mark" aria-label="Yodl"><span>Y</span></div>
          <h1 id="startup-recovery-title">Yodl needs a quick refresh</h1>
          <p className="auth-lede">Your account is safe. This page could not finish opening the latest secure version.</p>
          <button className="button button--primary" type="button" onClick={() => { window.location.reload(); }}>
            Reload Yodl
          </button>
          <p className="passkey-enrollment__note">If this appears again, close this Yodl window and reopen https://phiclaw.ai/yodl/.</p>
        </section>
      </main>
    );
  }
}
